import React from 'react';
import { useState, useEffect } from 'react';
import './classes/Mentor.css';
import { configData } from "../config";
import { liveCopyOrPlaceholder } from './liveImageFallback';

// conference: the block on a conference page, which the live theme heads "Speakers: Varies By
// Year" (block.tpl.php) instead of "Mentors". onLoaded(count) is told how many mentors there are.
// sides: the mentors in two columns as the live $$MENTORBLOCK$$ prints them in a course body, the
// 1st, 3rd, ... mentors stacked on the left and the 2nd, 4th, ... on the right (Body.js).
const Mentor = ({page, conference, onLoaded, sides}) => {
  const app_url = configData.APP_URL;
  const [content, setContent] = useState([]);

useEffect(() => {
//   setContent([
//   {
//     name: 'Larry Lundy',
//     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw',
//     bio: ['Sport & Athlete Branding Specialist'],
//     link: "#"
//   },
//   {
//     name: 'Dr Lynn Lashbrook',
//     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw',
//     bio: ['SMWW President & Founder', 'Certified NFL Agent', 'Former NCAA Athletic Director'],
//     link: "#"
//   }
// ]);
if(page?.nid) {
getmentors(page.nid);
}
}, [page]);
 const getmentors = async (nid) => {
    try {
     
      const postData = {
           nid: nid,
           
          };
          try {
            const response = await fetch(app_url + 'coursepages/getmentors', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              setContent(data.data.result);
              onLoaded && onLoaded(data.data.result.length);
            }
          } catch (err) {
             
        }
      
      
    } catch (err) {
      console.error(err);
    }
};
  // A picture that is missing on the server: the live site's copy of it, else the "not available"
  // image instead of a broken one (Mentor.css keeps any of them at the live crop's size)
  const placeholderImg = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/person_images/notavailable.jpg';
  const showPlaceholder = liveCopyOrPlaceholder(placeholderImg);
  // As on the live site, the block is left out when there is nothing to list
  if (!content.length) return null;
  const item = (mentor, idx) => (
    <li key={idx} className="mentor-item">
      {/* A mentor without a picture gets the "not available" one too (an img without a src
          never fails to load, so onError would not give it one) */}
      <img src={mentor.img || placeholderImg} alt={mentor.name} className="mentor-avatar" onError={showPlaceholder} />
      <a href={mentor.link} className="mentor-name-link">
        {mentor.name}
      </a>
       <span
          dangerouslySetInnerHTML={{
              __html:mentor.bio
          }}
      />

    </li>
  );
  if (sides) {
    return (
      <div className="course-mentor-card">
        <h2 className="mentor-header">Mentors</h2>
        {/* Live prints its cards display: block for two mentors and inline-block for more,
            which puts each card on a line with a gap under it (Mentor.css) */}
        <div className={'mentor-sides' + (content.length > 2 ? ' mentor-sides--lines' : '')}>
          <ul className="mentor-list mentor-side mentor-side--odd">
            {content.map((mentor, idx) => idx % 2 === 0 && item(mentor, idx))}
          </ul>
          <ul className="mentor-list mentor-side mentor-side--even">
            {content.map((mentor, idx) => idx % 2 === 1 && item(mentor, idx))}
          </ul>
        </div>
      </div>
    );
  }
  return (
    <div className="course-mentor-card">
      {conference ? (
        <h2 className="mentor-header">Speakers:<br /><span className="mentor-header__sub">Varies By Year</span></h2>
      ) : (
        <h2 className="mentor-header">Mentors</h2>
      )}
      <ul className="mentor-list">
        {content.map(item)}
      </ul>
    </div>
  );
};
export default Mentor;